exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#savedLinks {\n    text-align: center;\n    min-height: 100px;\n}\n.clickable{\n    cursor: pointer;\n}\n", ""]);

// exports
